module.exports = __webpack_public_path__ + "img/fck.e55c4939.png";